var _defs, _path, _path2, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a760b6f1-1e55-4349-bcad-563b81ab52cb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b715ec20-95db-414c-982b-71456fb0c9ab",
    x1: -6784.85,
    y1: 1118.78,
    x2: -6784.85,
    y2: 1089.98,
    gradientTransform: "matrix(0.5, 0, 0, -0.5, 3400.41, 559.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#589eed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4897e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2e8ce1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0a7cd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f7e46209-f134-49aa-a850-2e9a1b04fba6",
    x1: -1.47,
    y1: 14.91,
    x2: 17.16,
    y2: 14.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#449cdd",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#2870ab",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2469a3",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#1a5991",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#144f86",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#124c82",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#002851",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2f7ab6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#449cdd",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b36c7b72-34c8-47c6-ac8b-a96783f174f2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.26,
    cy: 13.27,
    r: 4.16,
    fill: "none"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-identity-225") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61,10.65H9.94V15H5.61Zm-5-5.76H4.89V.57H1.17a.6.6,0,0,0-.6.6ZM1.17,15H4.89V10.65H.57v3.72A.6.6,0,0,0,1.17,15Zm-.6-5H4.89V5.61H.57Zm10.09,5h3.72a.6.6,0,0,0,.6-.6V10.65H10.66Zm-5-5H9.94V5.61H5.61Zm5.05,0H15V5.61H10.66Zm0-9.36V4.89H15V1.17a.6.6,0,0,0-.6-.6Zm-5,4.32H9.94V.57H5.61Z",
    fill: "url(#b715ec20-95db-414c-982b-71456fb0c9ab)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.66,15h4.15a.59.59,0,0,1-.18-.29h-4Z",
    opacity: 0.95,
    fill: "url(#f7e46209-f134-49aa-a850-2e9a1b04fba6)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.26,
    cy: 13.27,
    r: 4.16,
    fill: "#32bedd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b36c7b72-34c8-47c6-ac8b-a96783f174f2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.06,13.87c-.21.11-.51.05-.65.16a1.6,1.6,0,0,0-.63.66c0,.06,0,.15-.07.18-.28.19-.56.39-.3.81-.3,0-.2-.27-.34-.35a.77.77,0,0,0-1.06.54.34.34,0,0,0,.16.37.26.26,0,0,0,.36-.12.18.18,0,0,1,.26-.06c0,.16-.28.45.18.46.12,0,.09.14.06.23s.06.24.19.3,0,0,0,.05,0,0,0,0c-.37,0-.45-.45-.81-.5a4.28,4.28,0,0,1-.43-.14c-.27-.09-.58-.14-.64-.54a.77.77,0,0,0-.36-.49c-.12-.08-.19-.23-.31-.32a1,1,0,0,0-.22-.36.94.94,0,0,1-.14-.87,2.32,2.32,0,0,0-.1-1.68c-.1-.32-.12-.65-.48-.86s-.3.12-.44.05-.22.13-.26.15c-.29.08-.54.33-.91.29.14-.07.25-.11.35-.17s.29-.14.07-.38-.14-.59.45-.83c-.05-.14-.41-.11-.25-.37s.28-.13.43,0c.1-.19-.12-.43.05-.54a2.86,2.86,0,0,1,.72-.29.25.25,0,0,1,.34.11c.18.28.54.33.72.61.05.09.15,0,.22,0,.41-.14.68.12,1,.33s.27.34.53.31a.49.49,0,0,1,.21,0c.16.07.31.11.43-.06a.3.3,0,0,0,.26-.23c.06-.09.09-.22.24-.16A1.15,1.15,0,0,0,16,11c.13-.1.26-.16.11-.39a.37.37,0,0,1,.25-.56.54.54,0,0,1,.63.23c.19.34.25.73.47,1,.07.09,0,.13,0,.2s-.18,0-.28-.06l.07.43a.66.66,0,0,1-.82-.25c0-.12,0-.17.12-.23s.19-.11.19-.24a.19.19,0,0,0-.1-.2c-.08,0-.13,0-.15.09s-.33.25-.28.53-.19.22-.33.14c-.33-.17-.45.13-.59.29s0,.34.16.46.31.21.37.4a.88.88,0,0,0,.29-.58c0-.18.07-.43.32-.46a.43.43,0,0,1,.44.28c.05.11.13.12.23.13a8.79,8.79,0,0,1,.54,1.52l-.37-.05c0-.29-.25-.16-.39-.22C16.84,13.64,17.07,13.69,17.06,13.87Z",
    fill: "#b4ec36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.62,10.27c-.13-.12-.27-.23-.06-.4s.2-.29.3,0A.37.37,0,0,1,15.62,10.27Z",
    fill: "#b4ec36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.93,9.87c.11-.11.25-.1.27,0s-.13.19-.26.23S15.85,10,15.93,9.87Z",
    fill: "#b4ec36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.16,8.94,14.81,9c0-.25.25-.27.42-.23S15.21,8.89,15.16,8.94Z",
    fill: "#b4ec36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpn);
export default __webpack_public_path__ + "static/media/Spn.c37d96e05410fcb7aa9b76d85e20d4c9.svg";
export { ForwardRef as ReactComponent };